import React, { useEffect } from "react";
import { Button, Link, Image } from "@heroui/react";
import Nav from "@/components/DeckBuilder/Mobile/Nav";
import CardDB from "@/components/DeckBuilder/Mobile/CardDB";
import Deck from "@/components/DeckBuilder/Mobile/Deck";
import Stats from "@/components/DeckBuilder/Mobile/Stats";
import { IconDotsVertical } from "@tabler/icons-react";
import Filters from "@/components/DeckBuilder/Mobile/Filters";
import Export from "@/components/DeckBuilder/Mobile/Export";
import FiltersMobileModal from "@/components/DeckBuilder/FiltersMobileModal";
import { adjustViewportForIOS } from "@/lib/viewport";
import { usePathname } from "next/navigation";
import LAYOUTS from "@/components/DeckBuilder/layouts";
import { CDN } from "@/lib/cdn";

export default function View({
  deck,
  getCount,
  copyDeck,
  filters,
  setFilter,
  clearAllFilters,
  deckCardsMap,
  displayCards,
  handleOpen,
  layout,
  setLayout,
  hasNextPage,
  fetchNextPage,
  clearNewDeck,
  setHoveredAACardId,
  searchDisplay,
  setSearchDisplay,
  setPage,
  page,
}: {
  deck: any;
  getCount: any;
  copyDeck: any;
  filters: any;
  setFilter: any;
  clearAllFilters: any;
  deckCardsMap: any;
  displayCards: any;
  handleOpen: any;
  layout: any;
  setLayout: any;
  hasNextPage: any;
  fetchNextPage: any;
  clearNewDeck: any;
  setHoveredAACardId: any;
  searchDisplay: any;
  setSearchDisplay: any;
  setPage: any;
  page: number;
}) {
  useEffect(() => {
    setPage(1);
  }, [layout, setPage]);

  const pathname = usePathname();

  useEffect(() => {
    // hack that prevents iphone from zooming in, but doesnt mess up android
    adjustViewportForIOS();
  }, [pathname]);

  let topNav;
  if (layout === LAYOUTS.EDIT) {
    topNav = (
      <Filters
        filters={filters}
        setFilter={setFilter}
        clearAllFilters={clearAllFilters}
        deckCardsMap={deckCardsMap}
        searchDisplay={searchDisplay}
        setSearchDisplay={setSearchDisplay}
      />
    );
  } else {
    topNav = (
      <div className="flex flex-row p-2 items-center justify-center">
        <div className="basis-[35px] mr-2 mt-2">
          <Link href="/">
            <Image
              src={`${CDN}/shared/logo/gumgum.png`}
              loading="eager"
              alt="gumgum.gg OPTCG fan site"
              height={35}
              width={35}
              className="sm:mb-2"
            />
          </Link>
        </div>
        <div className="grow">
          <div className="mb-2">
            <Export deck={deck} />
          </div>
          <Button color="danger" size="sm" onPress={() => clearNewDeck()}>
            Clear Deck
          </Button>
        </div>
      </div>
    );
  }

  let currentView = (
    <Deck
      getCount={getCount}
      handleOpen={handleOpen}
      setHoveredAACardId={setHoveredAACardId}
    />
  );
  if (layout === LAYOUTS.EDIT) {
    currentView = (
      <CardDB
        filters={filters}
        displayCards={displayCards}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
        page={page}
      />
    );
  } else if (layout === LAYOUTS.STATS) {
    currentView = <Stats deck={deck} getCount={getCount} />;
  }

  return (
    <div
      style={{
        maxHeight: "100svh",
        height: "100svh",
      }}
    >
      {topNav}
      <div>
        {currentView}
        <Nav getDeckCount={getCount} view={layout} setView={setLayout} />
      </div>
    </div>
  );
}
